import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On every route or hash change:
 * - If a hash is present, smoothly scroll to the element with that id
 *   (using CSS `scroll-margin-top` on the target to account for the sticky header).
 * - Otherwise, jump to the top of the page.
 */
export default function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      // Wait a tick so the destination page has rendered.
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo({ top: 0, behavior: "auto" });
        }
      }, 50);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}
